var map = {
	"./29/YoloWallet.json": 20073,
	"./30/YoloWallet.json": 34307,
	"./31/YoloWallet.json": 77058,
	"./32/YoloWallet.json": 28637,
	"./33/YoloWallet.json": 98852,
	"./34/YoloWallet.json": 77927,
	"./35/YoloWallet.json": 11686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23669;